import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "店舗コード", enum: "CUSTOMER" },
  { value: 2, text: "配送先コード", enum: "DELIVERY" },
]);
